import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { usePlayerNamePublic } from "./../util/db";
import FormAlert from "./FormAlert";

function DashboardAccountInfo({ auth }) {
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
    // } = usePlayerName(auth.user.id);

    //cast as big int
  } = usePlayerNamePublic(auth.user.id);

  const date = new Date(auth.user.created_at); // Replace with your date variable

  // Extract month, day, and year
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  // Format the date as MM-DD-YYYY
  const formattedDate = `${month}-${day}-${year}`;

  return (
    <Card className="mb-3">
      <Card.Header style={{ background: "#2D083F", color: "white" }}>
        <Card.Title className="mb-0" style={{ color: "white" }}>
          Account Information
        </Card.Title>
      </Card.Header>
      <Card.Body style={{ background: "#FFFFFF" }}>
        {itemsError && (
          <div className="mb-3">
            <FormAlert type="error" message={itemsError.message} />
          </div>
        )}

        <div className="mb-3 pb-3 border-bottom">
          <strong className="text-muted d-block mb-1">Name</strong>
          {itemsStatus === "success" && items && items.length > 0 ? (
            <span className="h6 mb-0" style={{ color: "#495057" }}>
              {items[0].name}
            </span>
          ) : itemsStatus === "loading" ? (
            <span className="h6 mb-0" style={{ color: "#495057" }}>
              Loading...
            </span>
          ) : (
            <span className="h6 mb-0" style={{ color: "#495057" }}>
              {auth.user.name}
            </span>
          )}
        </div>

        <div className="mb-3 pb-3 border-bottom">
          <strong className="text-muted d-block mb-1">Email</strong>
          <span className="h6 mb-0" style={{ color: "#495057" }}>
            {auth.user.email}
          </span>
        </div>

        <div className="mb-3 pb-3 border-bottom">
          <strong className="text-muted d-block mb-1">Member Since</strong>
          <span className="h6 mb-0" style={{ color: "#495057" }}>
            {formattedDate}
          </span>
        </div>

        <div className="mb-0">
          <strong className="text-muted d-block mb-1">Account Settings</strong>
          <Link
            to="/settings/general"
            className="h6 mb-0 text-decoration-none"
            style={{ color: "#2D083F" }}
          >
            Manage Account Settings
          </Link>
        </div>
      </Card.Body>
      <Card.Footer
        style={{
          background: "#2D083F",
          color: "white",
        }}
      />
    </Card>
  );
}

export default DashboardAccountInfo;
